import axiosInstance from '@api/axios.ts';
import { urls } from '@api/urls.ts';
import {
  DocumentInstance,
  DocumentInstanceHTMLContent,
  DocumentInstanceOriginalContent,
} from '@app/types/document-instance';
import { saveBlobToDisk } from '@utils/utils.ts';

export const deleteDocumentInstance = async (id: number): Promise<void> => {
  const response = await axiosInstance.delete(urls.documentInstance.byId(id));

  return response.data;
};

export const getDocumentInstance = async (
  id: number
): Promise<DocumentInstance> => {
  const response = await axiosInstance.get(urls.documentInstance.byId(id));

  return response.data;
};

export const getDocumentInstanceHTMLContent = async (
  id: number
): Promise<DocumentInstanceHTMLContent> => {
  const response = await axiosInstance.get(
    urls.documentInstanceVersion.getHtmlContent(id)
  );

  return response.data;
};

export const getDocumentInstanceExhibits = async (id: number): Promise<any> => {
  const response = await axiosInstance.get(
    urls.documentInstanceVersion.getExhibits(id)
  );
  return response.data;
};

export const getDocumentInstanceOriginalContent = async (
  id: number,
  s3BucketUrl: string,
  pageNumber: number
): Promise<DocumentInstanceOriginalContent> => {
  const response = await axiosInstance.get(
    urls.documentInstanceVersion.getOriginalContent(id),
    {
      params: {
        s3_bucket_url: s3BucketUrl,
        page_number: pageNumber,
      },
    }
  );
  return response.data;
};

export const cancelDocumentInstance = async (id: number): Promise<void> => {
  const response = await axiosInstance.post(
    urls.documentInstance.cancelGeneration(id)
  );

  return response.data;
};

export const updateDocumentInstance = async (
  id: number | string,
  data: any
): Promise<DocumentInstance> => {
  const response = await axiosInstance.patch(
    urls.documentInstance.byId(Number(id)),
    data
  );

  return response.data;
};

export const downloadDocumentInstanceDocx = async (
  id: number,
  landscape?: boolean
): Promise<void> => {
  const response = await axiosInstance.get(
    urls.documentInstance.exportDocx(id),
    {
      responseType: 'blob',
      params: landscape ? { orientation: 'landscape' } : undefined,
    }
  );
  saveBlobToDisk(response, `document_${id}.docx`);
};
